import React, { Component} from 'react';
import './About.css';
import { IconContext } from "react-icons";
import { BiChevronLeft, BiSidebar } from "react-icons/bi";


class About extends Component {
  constructor(props) {
    super(props);

    this.state = {
      
    };
  }

  componentDidUpdate(){
    
  }
 
  componentDidMount(){
    
  }

  render() {
    return (
      <div className = "aboutPage aboutScrollableSec fadeAboutAnimation">
        <div className = "aboutHeader">
        </div>
        <div className = "aboutContent1">
          
          <div className = "aboutText">
            <div className = "aboutTextWrapper">
              <p> The <strong>X-Lab</strong> is a multidisciplinary HCI lab based in the scenic University of British Columbia in Vancouver.</p>
              <p> Our research focusses on the intersection of sensors and signals, virtual and augmented reality, and human interactions in virtual worlds. 
                We perform a mix of investigative and technical methods, studying how people engage, perceive, and interact with technology. We design tools to
                support and improve people's interactions with technology.
              </p>
            </div>
          </div>
          <div className = "aboutPic">
            <div className = "aboutGarden" style = {{"backgroundImage" : "url('/pics/school.png')"}}>
                
            </div>
          </div>

        </div>
        <div className = "aboutContent2">
          
          <div className = "aboutText2">
            <div className = "aboutTextWrapper">
            <p>Our members come from a variety of different backgrounds, forming a strong interdisciplinary community predicated on learning and growth.</p>
            </div>
          </div>
          <div className = "aboutPic2">
            <div className = "aboutVancouver" style = {{"backgroundImage" : "url('/pics/vancouver.jpg')"}}>
                
            </div>
          </div>

        </div>
        <div className = "aboutFooter"></div>

      </div>
    )
  }
}

export default About;
